import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getAllSkillsForPerson = (personId) => dispatch => {
  dispatch({ type: "GET_ALL_SKILLS_FOR_PERSON_LOADING" });
  api
    .skillsGetAllForPerson(personId)
    .then(resp => {
      dispatch(operationSucceeded(resp.data));
      dispatch({ type: "GET_ALL_SKILLS_FOR_PERSON_LOADING_DONE" });
    })
    .catch(e => {
      jsError(e);
      dispatch({ type: "GET_ALL_SKILLS_FOR_PERSON_LOADING_DONE" });
      dispatch(operationFail());
      dispatch(buildAlertWithLocalizedMessages(
        "ERROR",
        "GetAllSkillsForPersonErrorAlertTitle",
        "Virhe henkilön taitojen haussa",
        e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
    });
};

const operationSucceeded = data => ({
  type: "GET_ALL_SKILLS_FOR_PERSON_SUCCEEDED",
  payload: { skills: data },
});

const operationFail = () => ({
  type: "GET_ALL_SKILLS_FOR_PERSON_FAIL",
});
